/* eslint-disable react/jsx-filename-extension */
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-named-as-default
import { toaster } from '@app/components/chakra/snippets/toaster';
import { bulkCloseJobs } from '../../../actions/job';
import MarleyModal from '../../elements/Modal/Modal';
import ButtonRow from '../../elements/buttons/ButtonRow/ButtonRow';
import Button from '../../elements/buttons/Button/Button';
import './CloseCaseConfirmation.less';

const CloseCaseConfirmation = ({ show, toggleModal, selectedJobs }) => {
  const dispatch = useDispatch();
  const numJobs = (selectedJobs && selectedJobs.length) || 0;
  const toastIdRef = useRef(null);

  const handleSubmitCaseClose = () => {
    const jobsToClose = selectedJobs.map((job) => ({
      jobId: job.id,
      isOpen: false,
      completedAt: new Date().toISOString(),
    }));
    const numJobs = jobsToClose.length;
    toastIdRef.current = toaster.create({
      title: `Closing ${numJobs} case${numJobs > 1 ? 's' : ''}...`,
      type: 'loading',
      duration: 5000,
    });
    dispatch(bulkCloseJobs(jobsToClose, toaster, toastIdRef));
    toggleModal(false);
  };
  return (
    <MarleyModal
      className="bulk-close-modal"
      title={`Are you sure you want to close ${numJobs} case${numJobs > 1 ? 's' : ''}?`}
      show={show}
      toggleModal={toggleModal}
      size="md"
    >
      <div className="message">
        You can reopen these cases through the action button in the closed cases list..
      </div>
      <ButtonRow>
        <Button type="positive" onClick={handleSubmitCaseClose}>Close All Cases</Button>
      </ButtonRow>
    </MarleyModal>
  );
};

CloseCaseConfirmation.propTypes = {
  show: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  selectedJobs: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default CloseCaseConfirmation;
